export default "__VITE_ASSET__7Dw2ccIY__"